const getters = {
  company_products: (state) => state.company_products, // productos de la empresa
  paginate_company_products: (state) => state.paginate_company_products, // paginacion de productos
  default_currencies: (state) => state.default_currencies, // monedas
  fields_company_products: (state) => state.fields_company_products, //campos personalizados de productos
  paginate_fields_products: (state) => state.paginate_fields_products, // paginacion de los campos
}

export default getters
